export const redirectOnError = (baseUrl: string, message: string, code: string) => `${baseUrl}/?message=${encodeURIComponent(message)}&code=${code}`;

export const redirectOnChallengeTransactionError = (baseUrl: string, message: string, trk: string) =>
    (window.location.href = `${baseUrl}/?res=false&msg=${encodeURIComponent(message)}&trk=${trk}`);
